export const locale = {
  lang: 'fr',
  data: {
    PRONOSTICO: {
      PRONOSTICO_SUCCESS: 'Succès',
      PRONOSTICO_ERROR: 'Erreur',
      PRONOSTICO_COMMUNICATION_ERROR: 'Erreur de communication'
    }
  }
}
